export const SET_CURRENT_PAGE_STORAGE = 'list/SET_CURRENT_PAGE_STORAGE'
export const SET_LAST_PAGE_STORAGE = 'list/SET_LAST_PAGE_STORAGE'



// WEBPACK FOOTER //
// ./src/vuex/modules/list/types.js